import axios from 'axios';

import { SAMARITAN_URL } from '../settings';

async function getToken(
    username: string,
    password: string,
    code: string,
    callback: Function
) {
    let userLoginRoute = `${SAMARITAN_URL}/api/v2/users/sign_in`;
    const credentials: {
        user: {
            email: string;
            password: string;
            otp_attempt?: string;
        };
    } = {
        user: {
            email: username,
            password: password
        }
    };
    
    if (code && code !== '') {
        credentials.user.otp_attempt = code;
    };
    
    return axios
        .post(userLoginRoute, credentials)
        .then((response) => {
            callback(response);
        })
        .catch((error) => {
            console.error(error);
            callback(error);
        });
}

async function sendCode(
    email: string,
    callback: Function,
    preferText?: boolean
) {
    const sendOtpRoute = `${SAMARITAN_URL}/api/v2/users/send_otp`;

    const userParams: { email: string; prefer_text?: boolean } = {
        email
    };

    // Only include prefer_text when explicitly true or false — never omit as empty
    if (typeof preferText === 'boolean') {
        userParams.prefer_text = preferText;
    }

    return axios
        .post(sendOtpRoute, {
            user: userParams
        })
        .then((response) => {
            callback(response);
        })
        .catch((error) => {
            console.error(error);
            callback(error);
        });
}


export { getToken, sendCode };
